import { useIntl } from "react-intl";

type HeroBannerItem = {
  id: string;
  heroBannerItemImageSrc: string;
  heroBannerItemImageAlt: string;
};

const useHeroBannerList = (): HeroBannerItem[] => {
  const intl = useIntl();

  return [
    {
      id: "listing_1",
      heroBannerItemImageSrc:
        "https://img.peerspace.com/image/upload/c_limit,w_920,f_auto,q_auto/v1780512812/host_page/listing_1",
      heroBannerItemImageAlt: intl.formatMessage({
        defaultMessage: "Listings banner",
      }),
    },
    {
      id: "listing_2",
      heroBannerItemImageSrc:
        "https://img.peerspace.com/image/upload/c_limit,w_920,f_auto,q_auto/v1780512812/host_page/listing_2",
      heroBannerItemImageAlt: intl.formatMessage({
        defaultMessage: "Listings banner",
      }),
    },
    {
      id: "listing_3",
      heroBannerItemImageSrc:
        "https://img.peerspace.com/image/upload/c_limit,w_920,f_auto,q_auto/v1780512812/host_page/listing_3",
      heroBannerItemImageAlt: intl.formatMessage({
        defaultMessage: "Listings banner",
      }),
    },
  ];
};

export { useHeroBannerList };
